import { DexNamesEnum } from '@shared/enums/dex-names.enum';
import { MigrationSnipeWizardStepEnum } from './migration-sniper.interfaces';

export const DEX_FOR_MIGRATION_SNIPER = [
    DexNamesEnum.bonkfun,
    DexNamesEnum.raydium_launchlab,
    DexNamesEnum.pumpfun,
    DexNamesEnum.moonit,
    DexNamesEnum.bonkfun,
    DexNamesEnum.meteora_dbc,
    DexNamesEnum.lesgofun,
    DexNamesEnum.surge,
];

export const MIGRATION_SNIPER_STATUS_LABELS = {
    [MigrationSnipeWizardStepEnum.created]: 'Created',
    [MigrationSnipeWizardStepEnum.validation]: 'Validation',
    [MigrationSnipeWizardStepEnum.completed]: 'Completed',
};
